export const companyConstants = {
  ADD_REQUEST: 'COMPANY_ADD_REQUEST',
  ADD_SUCCESS: 'COMPANY_ADD_SUCCESS',
  ADD_FAILURE: 'COMPANY_ADD_FAILURE',

  GETALL_REQUEST: 'COMPANY_GETALL_REQUEST',
  GETALL_SUCCESS: 'COMPANY_GETALL_SUCCESS',
  GETALL_FAILURE: 'COMPANY_GETALL_FAILURE',

  DELETE_REQUEST: 'COMPANY_DELETE_REQUEST',
  DELETE_SUCCESS: 'COMPANY_DELETE_SUCCESS',
  DELETE_FAILURE: 'COMPANY_DELETE_FAILURE',

  ACTIVE_REQUEST: 'COMPANY_ACTIVE_REQUEST',
  ACTIVE_SUCCESS: 'COMPANY_ACTIVE_SUCCESS',
  ACTIVE_FAILURE: 'COMPANY_ACTIVE_FAILURE',

  GETBYID_REQUEST: 'COMPANY_GETBYID_REQUEST',
  GETBYID_SUCCESS: 'COMPANY_GETBYID_SUCCESS',
  GETBYID_FAILURE: 'COMPANY_GETBYID_FAILURE',

  GETALL_PAGE_REQUEST: 'COMPANY_GETALL_PAGE_REQUEST',
  GETALL_PAGE_SUCCESS: 'COMPANY_GETALL_PAGE_SUCCESS',
  GETALL_PAGE_FAILURE: 'COMPANY_GETALL_PAGE_FAILURE',

  BULK_ADD_REQUEST: 'BULK_ADD_REQUEST',
  BULK_ADD_SUCCESS: 'BULK_ADD_SUCCESS',
  BULK_ADD_FAILURE: 'BULK_ADD_FAILURE',

  BULK_UPDATE_REQUEST: 'BULK_UPDATE_REQUEST',
  BULK_UPDATE_SUCCESS: 'BULK_UPDATE_SUCCESS',
  BULK_UPDATE_FAILURE: 'BULK_UPDATE_FAILURE',

  BULK_FILE_UPLOAD_LOG_REQUEST : 'BULK_FILE_UPLOAD_LOG_REQUEST',
  BULK_FILE_UPLOAD_LOG_SUCCESS: 'BULK_FILE_UPLOAD_LOG_SUCCESS',
  BULK_FILE_UPLOAD_LOG_FAILURE: 'BULK_FILE_UPLOAD_LOG_FAILURE',
  

  BULK_FILE_UPLOAD_DELETE_REQUEST : 'BULK_FILE_UPLOAD_DELETE_REQUEST',
  BULK_FILE_UPLOAD_DELETE_SUCCESS: 'BULK_FILE_UPLOAD_DELETE_SUCCESS',
  BULK_FILE_UPLOAD_DELETE_FAILURE: 'BULK_FILE_UPLOAD_DELETE_FAILURE',
  MESSAGE_CLEAR: 'MESSAGE_CLEAR',
  MESSAGE_ADD_CLEAR: 'MESSAGE_ADD_CLEAR',
  UPDATE_SUB_BRAND: 'UPDATE_SUB_BRAND' 
}
